import { toast } from "react-toastify";
import {
  fetchStockoutCreationSOStart,
  fetchStockoutCreationSOSuccess,
  fetchStockoutCreationSOFailure,
} from "./reducer";
import { STOCK_OUT_CREATION_SO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const stockoutCreationSO =
  (referenceId, jsonObj, setLoading, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchStockoutCreationSOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        STOCK_OUT_CREATION_SO(referenceId),
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(
          fetchStockoutCreationSOFailure(response.error.message)
        );
        toast.error(response.error.message);
      } else {
        dispatch(fetchStockoutCreationSOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Product has been stocked out successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(
        fetchStockoutCreationSOFailure("Something went wrong")
      );
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };